angular.module('SpidApp')

.service('BarcodePageBuilder',
[
function () {
    var BarcodePageBuilder = {
        generate: function (params) {
            params = params || {}
            
            if (!params.imageDataUri || !params.label || !params.barcode) {
                throw 'BarcodePageBuilder::generate() - Missing parameters'
            }
            
            var doc = new jsPDF()

            doc.text(params.label,   30, 15)
            doc.text(params.barcode, 30, 25)
            
            for(var i = 0 ; i < 6 ; i++) {
                doc.addImage(params.imageDataUri, 'JPEG',  30, 40 + i*42, 60, 20) // Left part
                doc.addImage(params.imageDataUri, 'JPEG', 120, 40 + i*42, 60, 20) // Right part
            }

            return doc.output('datauristring')
        }
    }
    
    return BarcodePageBuilder
}])